import { Icon } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import {
  MdQuiz,
  MdVideoLibrary,
  MdVideoSettings,
  MdArticle,
  MdFileCopy,
} from 'react-icons/md';
import {
  INTERACTIVE_ID,
  QUIZ_ID,
  VIDEO_ID,
  NARRATIVE_ID,
  FILE_SUBMISSION_ID,
} from 'utils/constants/subQuestType';

function SubQuestIcon({ typeId, ...rest }) {
  return (
    <>
      {typeId === VIDEO_ID && <Icon as={MdVideoLibrary} {...rest} />}
      {typeId === NARRATIVE_ID && <Icon as={MdArticle} {...rest} />}
      {typeId === QUIZ_ID && <Icon as={MdQuiz} {...rest} />}
      {typeId === INTERACTIVE_ID && <Icon as={MdVideoSettings} {...rest} />}
      {typeId === FILE_SUBMISSION_ID && <Icon as={MdFileCopy} {...rest} />}
    </>
  );
}

SubQuestIcon.propTypes = {
  typeId: PropTypes.number.isRequired,
};

export default SubQuestIcon;
